import HistoryContext from "@insite/mobius/utilities/HistoryContext";
import linkTo from "@store/utilities/linkTo";
import { useContext } from "react";

const useLinkTo = (url?: string) => {
    const { history } = useContext(HistoryContext);

    return () => linkTo(history, url);
};

export default useLinkTo;
